import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { selectLoginStatus } from "state/slices/loginSlice";

function PrivateRoute({ children }) {
  const isLoggedIn = useSelector(selectLoginStatus);
  const location = useLocation();

  // Redirect to login if the user is not logged in
  if (!isLoggedIn) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
}

export default PrivateRoute;
